/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DOWNLOAD_IMAGE: 'It was not possible download the image',
    ERROR: 'Error'
  },
  HEADER: {
    DESCRIPTION: 'Description',
    END_DATE: 'Until',
    ID: 'ID',
    START_DATE: 'On',
    TITLE: 'Title'
  },
  LABEL: {
    ACTIVES: 'Active campaigns',
    CAMPAIGNS_SIGN_OR: 'Or',
    CAMPAIGNS_SIGN_PLUS: '+',
    COUPON: 'Coupon',
    DESCRIPTION: 'Description',
    DESIGN_REQUESTS: 'Design requests',
    DESIGN_REQUESTS_ACTIVES: 'Active design requests',
    DESIGN_REQUESTS_TERMINATED: 'Completed design requests',
    DETAIL: 'Detail',
    END_DATE: 'Until',
    FILES_TITLE: 'Campaigns resources',
    FILES_TITLE_DESIGN_REQUEST: 'Resources for design applications',
    FINISHED: 'Finished',
    FINISHED_DESIGN_REQUEST: 'Finished',
    GENERATED: 'Generated',
    GENERIC_DESIGN: 'Generic design',
    ID: 'ID',
    IN_PROGRESS: 'In progress',
    NO_ROWS_CAMPAIGNS: 'No campaigns',
    NO_ROWS_DESIGN_REQUESTS: 'No design requests',
    OFFER: 'Offer',
    PREVIOUS_LEVEL: 'Previous level',
    START_DATE: 'On',
    STATUS: 'Status',
    TERMINATED: 'Past campaigns',
    TITLE: 'Title',
    VALUE: 'Value'
  },
  SENTENCE: {
    ATTACHMENT_DESCRIPTION: 'No attachments for this campaign (yet).',
    ATTACHMENT_DESCRIPTION_DESIGN_REQUEST:
      'No attachments for this design request (yet).',
    ATTACHMENT_TITLE: 'No attachments'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
